<template>
  <el-table :data="data" style="width: 100%;" :row-class-name="tableRowClassName" height="calc(100% - 140px)">
    <el-table-column label="序号" type="index" width="50">
    </el-table-column>
    <el-table-column prop="UserCode" label="客户代码" :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column prop="UserName" label="客户名称" :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column prop="AgentCode" label="代理人代码" :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column prop="AgentName" label="代理人名称" :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column prop="ContractNo" label="合约代码" :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column prop="ContractName" label="合约名称" :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column prop="Direction" label="方向">
      <template slot-scope="scope">
        <span>{{scope.row.Direction | GetDirection}}</span>
      </template>
    </el-table-column>
    <el-table-column prop="PositionEffect" label="开平">
      <template slot-scope="scope">
        <span>{{scope.row.PositionEffect | PositionEffect}}</span>
      </template>
    </el-table-column>
    <el-table-column prop="Volume" label="成交手数">
    </el-table-column>
    <el-table-column prop="Commission" label="手续费" v-if="SubAccountLimit">
    </el-table-column>
    <el-table-column prop="Price" label="成交价格">
    </el-table-column>
    <el-table-column prop="TradeDateTime" label="成交时间" :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column prop="CloseProfit" label="平仓盈亏" :show-overflow-tooltip="true">
    </el-table-column>
  </el-table>
</template>

<script>
import EnumConfig from "../../../assets/js/EnumConfig.js";
export default {
  // 成交明细表格
  name: "dealDetailT",
  data() {
    return {
      SubAccountLimit: true
    };
  },
  props: ["data"],
  created() {
    if (sessionStorage.getItem("type") == "1"){
      if (sessionStorage.getItem("SubAccountLimit") != null && sessionStorage.getItem("SubAccountLimit") != "undefined") {
        this.SubAccountLimit = JSON.parse(sessionStorage.getItem("SubAccountLimit"));
      }
    }
  },
  filters: {
    GetPositionEffectType(type) {
      return EnumConfig.GetPositionEffectType(type);
    },
    GetDirection(type) {
      return EnumConfig.GetDirection(type);
    },
    PositionEffect(type) {
      return EnumConfig.PositionEffect(type);
    }
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    handleClick(row) {
      //console.log(row);
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/selects/dealDetail/dealDetailT.vue